import { useQuery } from "@tanstack/react-query";
import { getMerchandisingPaList } from "../services/merchandisingPa.service";
import { QueryKeys } from "./queryKeys";

export const useMerchandisingPaList = () => {
  return useQuery({
    queryKey: [QueryKeys.MerchandisingPaList],
    queryFn: getMerchandisingPaList,
    staleTime: 1000 * 60 * 60 * 72, // 72 hours
    gcTime: 1000 * 60 * 60 * 72, // 72 hours
  });
};
